import React from 'react';
import { Card } from 'react-bootstrap';

const PreparationChecklistCard = () => {
	return (
		<Card>
			<Card.Body className='px-7 py-9'>
				<h5 className='fw-bold mb-4'>
					Preparation Checklist
				</h5>
				<ul className='mb-0'>
					<li className='mb-2'>Employee Information</li>
					<li className='mb-2'>Account Data</li>
					<li className='mb-2'>Books of Business</li>
					<li className='mb-2'>P&C Carrier Data</li>
					<li className='mb-2'>L&H Carrier Data</li>
					<li className='mb-2'>Non-Recurring Revenues and Expenses</li>
					<li>Profit/Loss Statements</li>
				</ul>
			</Card.Body>
		</Card>
	);
};

export default PreparationChecklistCard;
